<template>
  <Drawer :title="isOutside ? '新增渠道' : '新增机构'" v-model="visible" width="650" class="my-drawer" :mask-closable="false">
    <Form ref="form" :model="formData" :label-width="110" class="page-form less" v-if="visible">
      <h2 class="title">基础信息</h2>
      <FormItem prop="name" :label="isOutside ? '渠道简称' : '机构简称'" :rules="$units.formRule.required('请输入')" class="full">
        <Input v-model="formData.name" @on-blur="blurInpName($event)" placeholder="请输入" maxlength="16" />
      </FormItem>
      <FormItem prop="fullName" :label="isOutside ? '渠道全称' : '机构全称'" class="full">
        <Input v-model="formData.fullName" placeholder="请输入" maxlength="30" />
      </FormItem>
      <FormItem prop="innerCode" label="内部组织编码" :rules="$units.formRule.required('请输入')">
        <Input v-model="formData.innerCode" placeholder="请输入" />
      </FormItem>
      <FormItem prop="orgType" label="机构类型" :rules="$units.formRule.required('请选择')" v-if="!isOutside" key="orgType">
        <!-- 1、总部 2、省分 3、市级 4、区级 5、渠道' -->
        <Select v-model="formData.orgType">
          <Option value="2" v-if="[1, 2, 5].includes(curOrg.orgType * 1)">省分机构</Option>
          <Option value="3" v-if="[1, 2, 3, 5].includes(curOrg.orgType * 1)">市级机构</Option>
          <Option value="4" v-if="[1, 2, 3, 4, 5].includes(curOrg.orgType * 1)">区级机构</Option>
          <Option value="6" v-if="[1, 2, 3, 4, 5, 6].includes(curOrg.orgType * 1)">营业部</Option>
        </Select>
      </FormItem>
      <FormItem label="上级机构">
        <Input v-model="curOrg.name" disabled placeholder="请输入" />
      </FormItem>
      <FormItem prop="contacts" label="联系人">
        <Input v-model="formData.contacts" placeholder="请输入" />
      </FormItem>
      <FormItem prop="mobile" label="联系电话" :rules="$units.formRule.tel('请输入正确的手机号', false)">
        <Input v-model="formData.mobile" placeholder="请输入" />
      </FormItem>
      <FormItem prop="leaderId" label="机构负责人" v-if="!isOutside" key="leaderId">
        <lzSelect v-model="formData.leaderId" placeholder="请输入姓名或工号搜索" ref="leaderSelect" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem v-if="!isOutside && curOrg.parentId == '0'" prop="userId" label="推荐人" key="userId">
        <lzSelect v-model="formData.userId" placeholder="请输入姓名或工号搜索" :remote-method="getUserList">
          <template slot-scope="{ list }">
            <Option v-for="(item, i) in list" :key="i" :value="item.id" :label="item.name">
              <i class="dian" :class="{ 'red': item.workingState == 0, 'orange': item.isSus == 1 }"></i>
              {{ item.staffNo ? item.name + '-' + item.staffNo : item.name }}
            </Option>
          </template>
        </lzSelect>
      </FormItem>
      <FormItem prop="status" label="状态" :label-width="65" :rules="$units.formRule.required('请选择')">
        <RadioGroup v-model="formData.status">
          <Radio label="1">在营</Radio>
          <Radio label="2">停业</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="sortNum" label="排序">
        <template slot="label">
          排序
          <Tooltip content="数字越大，顺序越靠前" placement="top">
            <Icon type="md-help-circle" style="color: #a8adb7" />
          </Tooltip>
        </template>
        <Input v-model="formData.sortNum" placeholder="请输入" />
      </FormItem>
      <FormItem prop="postcode" label="邮编" v-if="!isOutside" key="postcode">
        <Input v-model="formData.postcode" placeholder="请输入" />
      </FormItem>
      <FormItem prop="orgCode" label="机构编码">
        <template slot="label">
          机构编码
          <Tooltip content="请填写保监的机构编码" placement="top" transfer>
            <Icon type="md-help-circle" style="color: #a8adb7" />
          </Tooltip>
        </template>
        <Input v-model="formData.orgCode" placeholder="请输入" />
      </FormItem>
      <FormItem prop="socialCode" label="社会信用代码" key="socialCode" :class="{ 'full': isOutside }">
        <Input v-model="formData.socialCode" placeholder="请输入" />
      </FormItem>

      <FormItem prop="templateId" label="服务费模板" class="full">
        <Select v-model="formData.templateId" placeholder="请选择" filterable style="width: 340px">
          <Option v-for="(item, i) in templateList" :value="item.id" :key="i">{{ item.name }}</Option>
        </Select>
        <span class="text-btn" @click="openTemplateEdit()" v-if="$units.pointAction('org_1_5')">创建模板</span>
      </FormItem>
      <FormItem label="监管报备" prop="supervise" class="full" v-if="$units.superviseShowVal()">
        <RadioGroup v-model="formData.supervise">
          <Radio label="0">否</Radio>
          <Radio label="1">是</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="所在省市" class="full" prop="city" :rules="$units.formRule.required('请选择')">
        <Select v-model="formData.province" placeholder="省" @on-change="provinceChange" filterable style="width: 50%">
          <Option v-for="(item, i) in regionsArr" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
        <Select v-model="formData.city" placeholder="市" filterable style="width: 48%; margin-left: 2%">
          <Option v-for="(item, i) in cityList" :value="item.name" :key="i">{{ item.name }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="address" label="地址" key="address" class="full">
        <Input v-model="formData.address" type="textarea" placeholder="最多不超过30个字" maxlength="30" :autosize="{ minRows: 1 }" show-word-limit />
      </FormItem>
      <FormItem prop="ico" label="公司logo" class="full" key="ico" v-if="formData.orgType == 5">
        <uploadNew class="upload-box" v-model="icoData" :muti="false" fileType="img" @change="uploadImg"></uploadNew>
        <span class="upload-info">建议LOGO图片大小：150px*150px</span>
      </FormItem>
      <FormItem label="备注" class="full">
        <Input v-model="formData.remark" type="textarea" placeholder="最多不超过50个字" maxlength="50" :autosize="{ minRows: 3 }" show-word-limit />
      </FormItem>

      <h2 class="title">财务信息</h2>
      <FormItem prop="taxpayerName" label="纳税人名称">
        <Input v-model="formData.taxpayerName" placeholder="请输入" />
      </FormItem>
      <FormItem prop="taxpayerNum" label="纳税人识别号">
        <Input v-model="formData.taxpayerNum" placeholder="请输入" />
      </FormItem>
      <FormItem prop="bank" label="开户行">
        <Select v-model="formData.bank" filterable clearable>
          <Option v-for="(txt, value) in bankList" :value="value" :key="value">{{ txt }}</Option>
        </Select>
      </FormItem>
      <FormItem prop="accountName" label="户名">
        <Input v-model="formData.accountName" placeholder="请输入" />
      </FormItem>
      <FormItem prop="cardNum" label="银行账号">
        <Input v-model="formData.cardNum" type="number" placeholder="请输入" />
      </FormItem>
      <FormItem prop="bankBranch" label="支行名称">
        <Input v-model="formData.bankBranch" placeholder="请输入" />
      </FormItem>
      <FormItem prop="invoiceType" label="发票类型">
        <Select v-model="formData.invoiceType" clearable filterable @on-change="changeInvoiceType">
          <Option value="1">专票</Option>
          <Option value="2">普票</Option>
          <Option value="3">其他</Option>
        </Select>
      </FormItem>
      <FormItem prop="invoiceTax" label="发票税点">
        <Input v-model="formData.invoiceTax" disabled />
      </FormItem>

      <div v-if="isOutside">
        <div class="form-title2">登录信息</div>
        <div class="user-form">
          <FormItem prop="username" label="姓名" :rules="[$units.formRule.required('请输入'), $units.formRule.str('请填写正确的姓名')]">
            <Input v-model="formData.username" placeholder="请输入" maxlength="20" />
          </FormItem>
          <FormItem prop="mobile3" label="手机号" :rules="$units.formRule.tel('请输入正确的手机号')" :label-width="60">
            <Input v-model="formData.mobile3" placeholder="请输入" />
          </FormItem>
          <FormItem prop="account" label="登录账号" :rules="[$units.formRule.required('请输入'), $units.formRule.str('不能含有特殊字符和标点符号')]">
            <Input v-model="formData.account" placeholder="请输入" maxlength="20" />
          </FormItem>
          <FormItem prop="contacts" label="角色" :label-width="60">
            <Input value="超级管理员" placeholder="请输入" disabled />
          </FormItem>
          <FormItem prop="password" label="登录密码" :rules="$units.formRule.required('请输入')" class="full">
            <Input v-model="formData.password" placeholder="请输入" style="width: 157px" />
            <div class="info-text">密码不少于8位，且必须包含大写字母、小写字母、数字、特殊字符中的任意三种</div>
          </FormItem>
        </div>
      </div>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible = false">取消</Button>
      <Button type="primary" @click="save" :loading="loading">确认</Button>
    </div>

    <!-- 新增模板 -->
    <edit-template ref="editTemplate" v-if="visible" @success="getTemplate"></edit-template>
  </Drawer>
</template>

<script>
import editTemplate from '@/components/commons/feeTemplate/editTemplate';
import uploadNew from '@/components/commons/uploadNew';
import lzSelect from '@/components/commons/lzSelect';
export default {
  components: {
    lzSelect,
    uploadNew,
    editTemplate
  },
  props: {},
  data() {
    return {
      visible: false,
      loading: false,
      isOutside: false, //是否是渠道
      formData: {},
      userInfo: {},
      curOrg: {}, //当前的节点数据
      regionsArr: [], //区域数据
      cityList: [], //市级数据
      templateList: [], //模板列表
      icoData: [],
      bankList: [], //银行
      dic: JSON.parse(localStorage.dic)
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
  },
  methods: {
    // 机构/渠道名称失去焦点
    blurInpName(e) {
      let value = e.target._value;
      if (value) {
        this.$set(this.formData, 'fullName', value);
      }
    },
    // 获取银行列表
    getBankList() {
      this.bankList = this.dic['BANK_TYPE'];
    },
    save() {
      this.$refs.form.validate().then(isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        formData.parentId = this.curOrg.id;
        formData.levelCode = this.curOrg.levelCode + 1;
        formData.orgCode = formData.orgCode ? formData.orgCode : formData.innerCode;
        const userList = this.$refs.leaderSelect.list;
        userList.forEach(item => {
          if (item.id == formData.leaderId) {
            formData.leaderType = item.type;
          }
        });
        if (this.isOutside) {
          formData.orgType = 5;
        }
        if (this.isOutside) {
          if (!this.verification(formData.password)) {
            return;
          }
          const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
          if (regTeShu.test(this.formData.account)) {
            this.$notice.error('登录账号支持输入数字、字母和汉字');
            return;
          }
        }
        if (this.loading) {
          return;
        }
        this.loading = true;
        this.$http({
          type: 'POST',
          url: '/buz/organizationBase/add',
          data: formData,
          apiPermissionCode: 'org_1_1'
        })
          .then(res => {
            this.$notice.success('提交成功');
            this.visible = false;
            this.$emit('success', res.data.id);
            localStorage.setItem('updataOrgAndTeam', 1);
          })
          .finally(res => {
            this.loading = false;
          });
      });
    },
    open(data, isOutside = false) {
      console.log('data------', data);
      this.curOrg = data;
      this.isOutside = isOutside;
      if (data.ico) {
        this.icoData = [{ path: data.ico }];
      } else {
        this.icoData = [];
      }
      this.formData = {
        status: '1',
        orgCode: '',
        innerCode: '',
        name: '',
        orgType: '',
        contacts: '',
        mobile: '',
        leaderId: '',
        province: '',
        city: '',
        sortNum: '',
        postcode: '',
        templateId: '',
        address: '',
        ico: data.ico,
        remark: '',
        username: '',
        mobile3: '',
        account: '',
        password: '',
        supervise: '1'
      };
      // this.$refs.form&&this.$refs.form.resetFields();
      this.visible = true;
      this.getRegion(); // 获取省市区域数据
      this.getTemplate(); //模板列表
      this.getBankList(); //开户银行
    },
    // 负责人列表
    getUserList(keyword) {
      if (!keyword) {
        return;
      }
      const params = {
        orgaList: [this.userInfo.organId],
        selectSub: 1,
        type: 3
      };
      if (/^\d{19}$/.test(keyword)) {
        // 初始化时keyword是id
        params.userId = keyword;
      } else {
        params.userName = keyword;
      }
      return this.$http({
        url: '/buz/userBase/getByOrgIds',
        type: 'POST',
        data: params
      }).then(res => {
        return res.data;
      });
    },
    //模板列表
    getTemplate() {
      this.$http({
        url: '/buz/template/getOrgTemplateList',
        type: 'GET',
        data: {
          orgId: this.curOrg.id,
          templateType: 1
        },
        apiPermissionCode: 'org_1_5'
      }).then(res => {
        this.templateList = res.data;
      });
    },
    // 获取省市区域数据
    async getRegion() {
      this.regionsArr = await this.$store.dispatch('getRegion');
    },
    // 选择省
    provinceChange(name) {
      this.$set(this.formData, 'city', '');
      const data = this.regionsArr.find(item => {
        return item.name == name;
      });
      this.cityList = data.children;
    },
    // 上传图片
    uploadImg(data) {
      console.log(data);
      data = data[0];
      if (data.h != data.w) {
        this.$notice.msg('请上传正方形图片');
        this.icoData = [];
      } else {
        this.$set(this.formData, 'ico', data.path);
      }
    },
    // 回显税点
    changeInvoiceType(val) {
      if (val == 1) {
        this.formData.invoiceTax = 0.02;
      } else if (val == 2) {
        this.formData.invoiceTax = 0.03;
      } else if (val == 3) {
        this.formData.invoiceTax = 0;
      } else {
        this.formData.invoiceTax = '';
      }
    },
    openTemplateEdit() {
      this.$refs.editTemplate.open(
        {
          type: '1',
          orgId: this.curOrg.id,
          orgName: this.curOrg.name
        },
        true
      );
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import './addOrg.scss';
</style>
